module.exports = __webpack_public_path__ + "static/img/homepage1.93c8c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/homepage1.jpg
// module id = snsl
// module chunks = 1